export function resourcesSlider() {
    let $sliders = $(".resources-slider");
    let $win = $(window);

    let initSliders = function () {
        $sliders.each(function () {
            let $slider = $(this);

            $slider.slick({
                slidesToShow: 1.025,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                infinite: false,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 744,
                        settings: {
                            slidesToShow: 2.2,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: "unslick",
                    },
                ]
            });
        });
    };

    if ($sliders.offset().top - $win.scrollTop() < 400 && $win.width() < 1200) {
        initSliders();
    }

    $win.on("scroll", function() {
        if ($sliders.offset().top - $win.scrollTop() < 400 && !$sliders.hasClass("slick-initialized") && $win.width() < 1200) {
            initSliders();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/resourcesSlider.js